import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-opacity": ".85",
  "fill-rule": "nonzero",
  d: "M11.969 1.846c-5.514 0-10 4.486-10 10s4.486 10 10 10 10-4.486 10-10-4.486-10-10-10m4.08 13.08a.714.714 0 1 1-1.012 1.009l-3.072-3.081-3.081 3.048a.714.714 0 1 1-1.004-1.015l3.078-3.045L7.89 8.766a.714.714 0 1 1 1.012-1.009l3.07 3.08 3.082-3.048a.714.714 0 1 1 1.004 1.016l-3.078 3.044z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }